$(document).ready(function () {
    // Scroll to top arrow
    $(window).on("scroll", function () {
        var top = $(document).scrollTop(),
            breakpoint = 2500,
            $scrollToTop = $(".js-scroll-to-top");

        if (top >= breakpoint) {
            return $scrollToTop.addClass("show");
        }

        return $scrollToTop.removeClass("show");
    });

    $(".js-animate-scroll").on("click", function (e) {
        e.preventDefault();

        var offset = -58;
        if ($(this).data("offset")) {
            offset = parseInt($(this).data("offset"), 10);
        }

        // store hash
        var hash = this.hash;

        // animate
        $("html, body").animate(
            {
                scrollTop: $(hash).offset().top + offset,
            },
            300,
            function () {
                // causes jerk, needs plugin for smoother thing probably
                //window.location.hash = hash;
            }
        );

        $(this).blur();
    });

    var anchors = $("a[href^=\\#]");
    if (anchors.length) {
        // Add smooth scrolling on all anchor links across the site
        $("a[href*=\\#]:not([href$=\\#],[data-no-scroll])").click(function () {
            event.preventDefault();
            $("html, body").animate(
                {
                    scrollTop: $($.attr(this, "href")).offset().top - 100,
                },
                500
            );
        });
    }
});
